import {deserialize, deserializeAs, serializeAs} from 'libs/cerialize';

export class ProjectManagerModel {
    @deserialize
    Id: number;

    @deserialize
    Name: string;
}